import { Grid } from '@mui/material';
import { memo } from 'react';
import DisplayFieldCard from './DisplayFieldCard';

const DisplayFieldGrid = ({ fields = [], selectedFields = [], onToggleField }) => (
  <Grid container spacing={2} justifyContent="flex-start">
    {fields.map((field) => (
      <Grid key={field.id}>
        <DisplayFieldCard field={field} checked={selectedFields.includes(field.id)} onToggle={onToggleField} />
      </Grid>
    ))}
  </Grid>
);

export default memo(DisplayFieldGrid);
